import { isRouteErrorResponse, useRouteError } from '@/shared/modern-router';

export const FiscalDataLegalEntitiesErrorBoundary = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <h1>
        {error.status} {error.statusText}
      </h1>
    );
  }

  return (
    <h1>
      {error instanceof Error
        ? error.message
        : typeof error === 'string'
          ? error
          : 'Unexpected error'}
    </h1>
  );
};

FiscalDataLegalEntitiesErrorBoundary.displayName =
  'FiscalData.LegalEntities.ErrorBoundary';
